import { isPresent } from '@luminovo/commons';

export type HtsComponent = 'heading' | 'hs-sub-heading' | 'us-sub-heading' | 'statistical-suffix';
export type HtsCodeResult =
    | { type: 'full'; formattedCode: string }
    | {
          type: 'partial';
          formattedCode: string;
          component: HtsComponent;
      }
    | { type: 'invalid' };

const HTS_REGEX =
    /^(?<chapter>\d{2})(?<heading>\d{2})\.?(?<hs_sub_heading>\d{2})?\.?(?<us_sub_heading>\d{2})?\.?(?<statistical_suffix>\d{2})?$/;

export function parseHtsCode(code: string | null | undefined): HtsCodeResult {
    if (!isPresent(code)) {
        return { type: 'invalid' };
    }

    const trimmedCode = code.trim();

    const result = trimmedCode.match(HTS_REGEX);
    if (!isPresent(result)) {
        return { type: 'invalid' };
    }

    const groups = result.groups;
    if (!isPresent(groups)) {
        return { type: 'invalid' };
    }

    const chapter = groups['chapter'];
    const heading = groups['heading'];
    const hsSubHeading = groups['hs_sub_heading'];
    const usSubHeading = groups['us_sub_heading'];
    const statisticalSuffix = groups['statistical_suffix'];

    return getHtsCodeResult({ chapter, heading, hsSubHeading, usSubHeading, statisticalSuffix });
}

type HtsCode = {
    chapter: string;
    heading: string;
    hsSubHeading: string | undefined;
    usSubHeading: string | undefined;
    statisticalSuffix: string | undefined;
};

function getHtsCodeResult(htsCode: HtsCode): HtsCodeResult {
    const { chapter, heading, hsSubHeading, usSubHeading, statisticalSuffix } = htsCode;
    let component: HtsComponent = 'heading';

    let code = `${chapter}${heading}`;

    if (isPresent(hsSubHeading)) {
        code = `${code}.${hsSubHeading}`;
        component = 'hs-sub-heading';
    }

    if (isPresent(usSubHeading)) {
        code = `${code}.${usSubHeading}`;
        component = 'us-sub-heading';
    }

    if (isPresent(statisticalSuffix)) {
        code = `${code}.${statisticalSuffix}`;
        component = 'statistical-suffix';
    }

    if (component === 'statistical-suffix') {
        return { type: 'full', formattedCode: code };
    }

    return {
        type: 'partial',
        component,
        formattedCode: code,
    };
}
